// extracted by mini-css-extract-plugin
export default {"container":"J1-z"};